export default (<any>window).Sentry;
